import PurchaseType from '@/utils/PurchaseType';
import axios from '@/axios';
import { toast } from 'vue3-toastify';
import { normalizeForBackend } from '@/utils/normalizeData';
import { getFieldValue } from '@/utils/getFieldValue';


const purchases = {
  state: () => ({
    usersPurchases: [],

    products: [],
    subscriptions: [],

    fetchProductsPromise: null
  }),
  actions: {
    fetchPurchases({ commit }, { startDate, endDate }) {
      const params = {
        startDate,
        endDate,
        order: 'DESC',
      };
      return new Promise((resolve, reject) => {
        axios.get(`/purchases`, { params }).then(response => {
          commit('setUserPurchases', response.data.data)
          resolve(response)
        }).catch(e => {
          reject(e)
          toast.error("Не удалось получить данные о платежах.");
        })
      })
    },

    fetchUserPurchases({ commit, state }, userUuid) {
      const today = new Date();

      const startDate = new Date(today);
      startDate.setFullYear(today.getFullYear() - 3);

      const endDate = new Date(today);
      endDate.setFullYear(today.getFullYear() + 3);

      const params = {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        order: 'DESC',
      };

      return new Promise((resolve, reject) => {
        axios.get(`/user/${userUuid}/purchases`, { params }).then(response => {
          const purchasesData = response.data.data || [];
          
          // Возможно, данные приходят в другом формате
          if (purchasesData.length === 0 && Array.isArray(response.data) && response.data.length > 0) {
            const purchasesDataFromArray = response.data;
            commit('setUsersPurchases', state.usersPurchases.filter(purchase => {
              const purchaseUserUuid = getFieldValue(purchase, 'userUuid', 'user_uuid');
              return purchaseUserUuid != userUuid;
            }));
            commit('setUserPurchases', purchasesDataFromArray);
            resolve(response);
            return;
          }
          
          // Удаляем старые покупки этого пользователя перед добавлением новых
          const purchasesWithoutUser = state.usersPurchases.filter(purchase => {
            const purchaseUserUuid = getFieldValue(purchase, 'userUuid', 'user_uuid');
            return purchaseUserUuid != userUuid;
          });
          
          // Временно заменяем покупки только для этого пользователя
          commit('setUsersPurchases', purchasesWithoutUser);
          
          // Добавляем новые покупки
          commit('setUserPurchases', purchasesData);
          resolve(response)
        }).catch(e => { reject(e); toast.error("Не удалось получить данные о платежах пользователя."); })
      })
    },
    fetchUserProduct({ commit }, uuid) {
      return new Promise((resolve, reject) => {
        axios.get(`/user-product/${uuid}`).then(response => {
          commit('setUserProduct', response.data)
          resolve(response)
        }).catch(error => reject(error))
      })
    },
    updateUserProduct({ commit }, { uuid, data }) {
      return new Promise((resolve, reject) => {
        axios.patch(`/user-product/${uuid}`, normalizeForBackend(data)).then(response => {
          const userPurchase = {
            ...response.data,
            type: PurchaseType.PRODUCT,
          };
          commit('updateOrCreateUserPurchase', userPurchase)
          toast.success("Данные покупки успешно обновлены!")
          resolve(response)
        }).catch(e => { reject(e); toast.error("Не удалось обновить данные покупки.") })
      })
    },
    updateUserSubscription({ commit }, { uuid, data }) {
      return new Promise((resolve, reject) => {
        axios.patch(`/user-subscription/${uuid}`, normalizeForBackend(data)).then(response => {
          const userPurchase = {
            ...response.data,
            type: PurchaseType.SUBSCRIPTION,
          };
          commit('updateOrCreateUserPurchase', userPurchase)
          toast.success("Данные покупки успешно обновлены!")
          resolve(response)
        }).catch(e => { reject(e); toast.error("Не удалось обновить данные покупки.") })
      })
    },

    issueUserProduct({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/user/product', normalizeForBackend(payload)).then(response => {
          const userPurchase = {
            ...response.data,
            type: PurchaseType.PRODUCT,
          };
          commit('updateOrCreateUserPurchase', userPurchase)
          toast.success('Продукт был успешно выдан.')
          resolve(response)
        }).catch(e => {reject(e); toast.error('При выдаче продукта произошла ошибка')})
      })
    },
    issueUserSubscription({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/user/subscription', normalizeForBackend(payload)).then(response => {
          const userPurchase = {
            ...response.data,
            type: PurchaseType.SUBSCRIPTION,
          };
          commit('updateOrCreateUserPurchase', userPurchase)
          toast.success('Подписка успешно выдана.')
          resolve(response)
        }).catch(e => {reject(e); toast.error('При выдачи подписки произошла ошибка')})
      })
    },

    updateSubscription({commit}, payload){
      const {name, timeRange, timeRangeCount, amount, description, products} = payload
      return new Promise((resolve, reject) => {
        axios.patch(`/subscription/${name}`, normalizeForBackend({
          timeRange,
          timeRangeCount,
          amount,
          description,
          products
        })).catch(error => reject(error))
        .then(response => {
          commit('updateSubscription', payload)
          resolve(response)
        })
      })
    },



    fetchProducts({ commit, state }) {
      if (!state.fetchProductsPromise) {
        state.fetchProductsPromise = new Promise((resolve, reject) => {
          axios.get('/products').then(response => {
            commit('setProducts', response.data)
            resolve(response)
          }).catch(e => reject(e))
        })
      }

      return state.fetchProductsPromise
    },
    fetchSubscriptions({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/subscriptions').then(response => {
          commit('setSubscriptions', response.data)
          resolve(response)
        }).catch(e => reject(e))
      })
    },
  },
  mutations: {
    setProducts(state, products) {
      state.products = products;
    },
    setSubscriptions(state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    setUserProduct(state, userProduct) {
      const userProductExistIndex = state.usersPurchases.filter(purchase => purchase.type == 'PRODUCT').findIndex(purchase => purchase.uuid == userProduct.uuid)
      const newUserPurchase = { ...userProduct, type: 'PRODUCT' }
      if (userProductExistIndex != -1) {
        Object.assign(state.usersPurchases[userProductExistIndex], newUserPurchase);
      } else {
        state.usersPurchases.push(newUserPurchase)
      }
    },
    setUsersPurchases(state, purchases) {
      state.usersPurchases = purchases;
    },
    setUserPurchases(state, purchases) {
      if (!Array.isArray(purchases)) {
        console.error('setUserPurchases: purchases is not an array', purchases);
        return;
      }

      // Если покупок нет, просто возвращаемся (старые данные уже очищены в fetchUserPurchases)
      if (!purchases || purchases.length === 0) {
        return;
      }
      
      // Объединяем текущие и новые покупки
      // ВАЖНО: state.usersPurchases уже содержит только покупки других пользователей (после cleanup в fetchUserPurchases)
      const allPurchases = [...state.usersPurchases, ...purchases];

      // Разделяем покупки по типам
      const products = [];
      const subscriptions = [];

      allPurchases.forEach(purchase => {
        // Определяем тип покупки: по полю type или по наличию subscription/product
        let purchaseType = purchase.type;
        if (!purchaseType) {
          if (purchase.subscription || purchase.subscription_uuid) {
            purchaseType = PurchaseType.SUBSCRIPTION;
          } else if (purchase.product || purchase.product_uuid || purchase.user_product_uuid) {
            purchaseType = PurchaseType.PRODUCT;
          }
        }

        // Добавляем тип к покупке, если его нет (сохраняем все поля, включая user_uuid)
        const purchaseWithType = { ...purchase, type: purchaseType };
        
        // Проверяем, что user_uuid сохраняется
        const originalUserUuid = purchase.user_uuid || purchase.userUuid;
        const preservedUserUuid = purchaseWithType.user_uuid || purchaseWithType.userUuid;
        if (originalUserUuid && !preservedUserUuid) {
          // Восстанавливаем user_uuid
          purchaseWithType.user_uuid = originalUserUuid;
        }

        if (purchaseType === PurchaseType.PRODUCT || purchaseType === "PRODUCT") {
          if (!products.some(p => p.uuid === purchase.uuid)) {
            products.push(purchaseWithType);
          }
        } else if (purchaseType === PurchaseType.SUBSCRIPTION || purchaseType === "SUBSCRIPTION") {
          if (!subscriptions.some(p => p.uuid === purchase.uuid)) {
            subscriptions.push(purchaseWithType);
          }
        } else {
          // Добавляем покупку даже без типа, чтобы не потерять данные
          if (!products.some(p => p.uuid === purchase.uuid) && !subscriptions.some(p => p.uuid === purchase.uuid)) {
            products.push(purchaseWithType);
          }
        }
      });

      // Объединяем обратно уникальные покупки
      state.usersPurchases = [...products, ...subscriptions];
    },

    updateOrCreateUserPurchase(state, purchaseToUpdate) {
      const userPurchasesIndex = state.usersPurchases.findIndex(purchase => purchase.uuid == purchaseToUpdate.uuid);
      if (userPurchasesIndex != -1) {
        Object.assign(state.usersPurchases[userPurchasesIndex], purchaseToUpdate)
      } else {
        state.usersPurchases.push(purchaseToUpdate)
      }
    }
  },
  getters: {
    usersPurchases: state => state.usersPurchases,
    userPurchases: state => uuid => {
      if (!uuid) return [];
      return state.usersPurchases.filter(purchase => {
        const purchaseUserUuid = getFieldValue(purchase, 'userUuid', 'user_uuid');
        return purchaseUserUuid == uuid;
      }) ?? [];
    },
    userProduct: state => uuid => state.usersPurchases.filter(userPurchase => userPurchase.type == 'PRODUCT').find(userProduct => userProduct.uuid == uuid),

    products: state => state.products,
    subscriptions: state => state.subscriptions,
  },
};

export default purchases;
